if (process.env.NODE_ENV === 'production') {
  module.exports = require('./theme-utils.production.js');
} else {
  module.exports = require('./theme-utils.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/theme-utils/dist/es/theme-utils.js
// module id = 29
// module chunks = 0